export const toggleScroll = (isDisabled = false) => {
  if (isDisabled) {
    document.body.style.overflow = 'hidden'
  }
  if (!isDisabled) {
    document.body.style.overflow = ''
  }
}
